import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getAllSharedReportUserPermission(userId, sharingType, sharingIds) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedReportUserPermission/${userId}/${sharingType}/${sharingIds}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function getShareById(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByShareId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function createSharing(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSharing`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function updateSharing(id, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateSharing/${id}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function deleteSharing(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteSharing/${id}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

export {
    getAllSharedReportUserPermission,
    getShareById,
    createSharing,
    updateSharing,
    deleteSharing
}
